/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayTeamObjectivesDtoSchema = z.object({
  dragons: z.number().nullish(),
  barons: z.number().nullish(),
  heralds: z.number().nullish(),
  voidgrubs: z.number().nullish(),
  inhibitors: z.number().nullish(),
});
